import { BlogStore } from "./stores/blog-store"
import type { IBlogStore } from "./interfaces"

export interface BlogNamespace {
  blogStore: IBlogStore
}

export class BlogNamespaceFactory {
  static create(): BlogNamespace {
    const blogStore = new BlogStore()
    
    return {
      blogStore,
    }
  }
}
